class ProductNavigation extends HTMLElement {
  itemsArray = []

  constructor () {
    super()

    this.sectionExternalEls = window.BAO.utils.getElements(
      '[data-external-el="product-navigation.section"]'
    )
    this.itemsEl = window.BAO.utils.getElement(
      '[data-el="product-navigation.items"]'
    )
    this.buttonEls = window.BAO.utils.getElements(
      '[data-el="product-navigation.button"]'
    )

    this.sectionExternalEls.forEach((section, index) => {
      this.buildItems(section.dataset.productNavigationTitle, index)
    })

    this.buttonEls.forEach(button => {
      button.addEventListener('click', this.onClick.bind(this))
    })
  }

  buildItems (link, index) {
    if (!this.itemsArray.includes(link.toLowerCase())) {
      this.itemsArray.push(link.toLowerCase())

      const item = document.createElement('li')
      item.classList.add('prd-Navigation_Item')

      const button = document.createElement('button')
      button.classList.add(
        'prd-Navigation_Link',
        'fz-12_18',
        'btn-Button',
        'btn-Button-secondary'
      )
      button.setAttribute('data-el', 'product-navigation.button')
      button.appendChild(document.createTextNode(link))

      item.appendChild(button)

      this.itemsEl.appendChild(item)

      this.buttonEls = window.BAO.utils.getElements(
        '[data-el="product-navigation.button"]'
      )

      // Only observe once all items are built
      if (index === this.sectionExternalEls.length - 1) {
        this.observeItems()
      }
    }
  }

  observeItems () {
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.7,
    }

    function observerCallback (entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const navItem = Array.from(
            document.querySelectorAll('[data-el="product-navigation.button"]')
          ).find(
            el => el.textContent === entry.target.dataset.productNavigationTitle
          )

          navItem.classList.add('prd-Navigation_Link-active')
          document
            .querySelectorAll('[data-el="product-navigation.button"]')
            .forEach(item => {
              if (item !== navItem) {
                item.classList.remove('prd-Navigation_Link-active')
              }
            })
        }
      })
    }

    // eslint-disable-next-line compat/compat
    const observer = new IntersectionObserver(observerCallback, observerOptions)

    this.sectionExternalEls.forEach(sec => observer.observe(sec))
  }

  onClick (e) {
    // Buffer in px
    const buffer = 350

    // Get the target element based on the clicked button
    const targetElement = window.BAO.utils.getElement(
      `[data-product-navigation-title="${e.target.firstChild.nodeValue}"]`
    )

    // Calculate the offset with the buffer
    const offsetWithBuffer =
      window.BAO.utils.getOffsetTop(targetElement) - buffer

    window.scrollTo({
      top: offsetWithBuffer,
      left: 0,
      behavior: 'smooth',
    })
  }
}

customElements.define('product-navigation', ProductNavigation)
